export default "<div [@slide]=\"{value: '', params: { speed: speed}}\">\n  <ng-content></ng-content>\n</div>\n"